export default __webpack_public_path__ + "static/Uffici-f6c429528450cc85e891bdd1095a7d23.jpg";